import React from "react";

type StackDirection = "horizontal" | "vertical";
type StackGap = "none" | "condensed" | "normal" | "spacious";
type StackAlign = "start" | "center" | "end" | "baseline";
type StackJustify = "start" | "center" | "end" | "space-between" | "space-evenly";
type StackWrap = "wrap" | "nowrap";

interface StackProps {
  direction?: StackDirection;
  gap?: StackGap;
  align?: StackAlign;
  justify?: StackJustify;
  wrap?: StackWrap;
  children?: React.ReactNode;
}

const Stack = ({ direction = "vertical", gap = "normal", align = "start", justify = "start", wrap = "nowrap", children }: StackProps) => {
  return (
    <div className="Stack" data-direction={direction} data-gap={gap} data-align={align} data-justify={justify} data-wrap={wrap}>
      {children}
    </div>
  );
};

export default Stack;
